import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/orgs/$orgId")({
  // Component moved to superadmin.orgs.$orgId.lazy.tsx for code splitting
});
